/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LockUnlockedIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABAklEQVR4nOWVS2oCQRCGZ+UBRBDRleeIe2G6Hi00VaNncJGQO2S8TszOeJvErFy50o2SOIpEezKO0yCk4N9V19f16OoougcDq31gnQHpCkjXSDInSqCa4KRjZN1eEpC+VAIA0iWiPhqTNJxzdWR5ApLND4TFRCHMkDxnmbyHAZikkZVpGYUyzHrxjwDOuRqyTIBk4RtN9I0syyeypt8x8m6UXhsYz5V6AWVujr9F+vVnTT0leAXQprWjFpJO83xLAeLYtQ9+1o46QQHxYNitHAAkb8desc4qB+DJwaJ+9wcwnDwQSS8YAAvKC8ie+62Aj6CrAvK+0f2y07RMJoWWXQjbAT7zBIgLTTs5AAAAAElFTkSuQmCC)
 */
export const LockUnlockedIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M8.7 2.25A4.98 4.98 0 0 1 17 6v3h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h9V6a3 3 0 0 0-4.98-2.25 1 1 0 0 1-1.33-1.5ZM14 14a2 2 0 0 1-1 1.73V18a1 1 0 1 1-2 0v-2.27A2 2 0 1 1 14 14Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
